import { client } from '@/common-utils/libraries/axios/axios';
import { REMOTE_COLLECTION } from '../apiUrls';

const mutationRefreshAlmaTransactions = (onSuccess, onError) => {
    return {
        mutationFn: ({ reconciliationNumber, contractNumber, application }) => {
            return client.post(
                REMOTE_COLLECTION.REFRESH_TRANSACTION_ALMA.url,
                { internalPaymentId: reconciliationNumber, contractNumber: contractNumber, application: application }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationRefreshAlmaTransactions;